import { type AvatarProps } from "@radix-ui/react-avatar";
import {
  Avatar as AvatarPrimitive,
  AvatarFallback,
} from "@vega-core/components/shadcn/avatar";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type Props = AvatarProps & {
  className?: string;
  disabled?: boolean;
  fontClassName?: string;
  initials?: string;
  showActive?: boolean;
  variant?: "outlined" | "primary" | "secondary";
  isLoading?: boolean;
};

export function Avatar({
  className,
  disabled = false,
  fontClassName,
  variant = "primary",
  initials,
  showActive,
  isLoading = false,
  ...props
}: Props) {
  if (initials == null) {
    return null;
  }

  return (
    <AvatarPrimitive
      className={cnTwMerge(
        "justify-center items-center w-10 h-10",
        {
          "skeleton-box w-10 h-10 rounded-full": isLoading,
        },
        className,
      )}
      data-testid="avatar"
      {...props}
    >
      <AvatarFallback
        className={cnTwMerge(
          "pl-2 pr-2 text-base font-bold leading-none body-base-regular bg-background/primary w-6 h-6 rounded-full",
          variant === "primary" && "bg-brand-default text-text/on-brand",
          variant === "secondary" && "bg-background/tertiary text-text/primary",
          variant === "outlined" &&
            "bg-background/primary border-1 border-brand-default",
          disabled && "bg-background/tertiary opacity-60",
          className,
        )}
        fontClassName={
          fontClassName ??
          (variant === "outlined"
            ? "body-small-semibold text-brand-default"
            : undefined)
        }
        showActive={showActive}
      >
        {initials}
      </AvatarFallback>
    </AvatarPrimitive>
  );
}
